import Button, { ButtonProps } from '@mui/material/Button';
import { grey } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { isDarkMode } from 'app/utils/ColorContext';

export const AppButton = ({
    action,
    variant,
    style = {},
    color = 'success',
    disabled,
    children,
    size,
}) => {
    const ColorButton = styled(Button)(({ theme }) => ({
        color: isDarkMode(theme) ? grey[50] : grey[900],
        backgroundColor: 'transparent',
        borderColor: isDarkMode(theme) ? grey[50] : grey[900],
        '&:hover': {
            backgroundColor: isDarkMode(theme) ? grey[600] : grey[300],
        },
    }));

    return (
        <ColorButton
            onClick={action}
            variant={variant}
            sx={style}
            disabled={disabled}
        >
            {children}
        </ColorButton>
    );
};
